var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacilityCardCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.83317H1.75M9.33333 1.1665V3.49984M4.66667 1.1665V3.49984M4.55 12.8332H9.45C10.4301 12.8332 10.9201 12.8332 11.2945 12.6424C11.6238 12.4747 11.8915 12.2069 12.0593 11.8777C12.25 11.5033 12.25 11.0133 12.25 10.0332V5.13317C12.25 4.15308 12.25 3.66303 12.0593 3.28869C11.8915 2.9594 11.6238 2.69169 11.2945 2.52391C10.9201 2.33317 10.4301 2.33317 9.45 2.33317H4.55C3.56991 2.33317 3.07986 2.33317 2.70552 2.52391C2.37623 2.69169 2.10852 2.9594 1.94074 3.28869C1.75 3.66303 1.75 4.15308 1.75 5.13317V10.0332C1.75 11.0133 1.75 11.5033 1.94074 11.8777C2.10852 12.2069 2.37623 12.4747 2.70552 12.6424C3.07986 12.8332 3.56991 12.8332 4.55 12.8332Z",
    stroke: "#006AB3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityCardCalenderIcon);
export default __webpack_public_path__ + "static/media/facility_Card_calender_icon.b1e2a0eec7df1f457af6e071a917bd84.svg";
export { ForwardRef as ReactComponent };